import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { AddMenuCategory$Params } from 'src/api/generated/fn/menu-v-2/add-menu-category';
import { UpdateMenuCategory$Params } from 'src/api/generated/fn/menu-v-2/update-menu-category';
import { AddMenuCategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuCategories/add-menu-category-dto';
import { MenuCategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-category-dto';
import { UpdateMenuCategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuCategories/update-menu-category-dto';
import { MenuV2Service } from 'src/api/generated/services';

@Component({
  selector: 'app-add-or-edit-menu-category',
  templateUrl: './add-or-edit-menu-category.component.html',
  styleUrls: ['./add-or-edit-menu-category.component.scss']
})
export class AddOrEditMenuCategoryComponent implements OnInit {

  public venueId: string;
  public unsubscribe: Subject<void> = new Subject<void>();
  public editFlag: boolean = false;
  public menuCategory: MenuCategoryDto = {} as MenuCategoryDto;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private menuV2Service: MenuV2Service
  ) {
    if (this.config.data != undefined) {
      if (this.config.data.item) {
        this.menuCategory.name = this.config.data.item.name;
        this.menuCategory.id = this.config.data.item.id;
        this.editFlag = true;
      }
      if (this.config.data.venueId) {
        this.venueId = this.config.data.venueId;
      }
    }
  }

  ngOnInit(): void {
  }

  addCategory(f: NgForm) {
    if(f.valid){
      var params: AddMenuCategory$Params = {} as AddMenuCategory$Params;
      const menuCategory: AddMenuCategoryDto = { name: this.menuCategory.name, venueId: this.venueId };
      params.body = menuCategory;
      this.menuV2Service.addMenuCategory(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }
  editCategory(f: NgForm) {
    if(f.valid){
      var params: UpdateMenuCategory$Params = {} as UpdateMenuCategory$Params;
      const menuCategory: UpdateMenuCategoryDto = { name: this.menuCategory.name };
      if(this.menuCategory.id){
        params.menuCategoryId = this.menuCategory.id;
      }
      params.body = menuCategory;
      this.menuV2Service.updateMenuCategory(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }
  close() {
    this.ref.close(null);
  }
}


